module.exports = __webpack_public_path__ + "img/Add Recipients.0f0af0e8.svg";